export const canRead = (role) => {
  return role == 'read';
};

export const canWrite = (role) => {
  return role == 'write' || role == 'manage';
};

export const userCan = (current_user, role) => {
  let read = current_user.admin || canRead(role);
  let write = current_user.admin || canWrite(role);
  return { canRead: read, canWrite: write, isAdmin: current_user.admin };
};
